<template>
      <div>
            <!-- Headline -->
            <div class="flex xs-12 mb2 xs-middle">
                  <div class="flex xs-6 xs-left fs5 lh125 fw7 c1">{{ $t("insured_objects") }}</div>
            </div>

            <!-- List -->
            <div v-for="insured in list" :key="insured.id">
                  <core-entity-card :entity="insured" :isExpanded="false" class="mb2">
                        <div
                              v-if="$store.state.settings.quotes.detail.hasRemoveInsured"
                              slot="footer"
                              class="flex xs-12 bt1 bc7 mt3"
                        >
                              <div class="flex mt3">
                                    <!-- Remove Insured Button -->
                                    <j-button
                                          type="error"
                                          size="xsmall"
                                          @click="removeInsured(insured.id)"
                                    >{{ $t("remove_insured") }}</j-button>
                              </div>
                        </div>
                  </core-entity-card>
            </div>

            <!-- Empty state -->
            <j-card v-if="list.length === 0" class="bg5 p3 ta2 fs3">
                  <div class="flex xs-12 xs-center xs-middle lh125 c1">{{ $t("errors.no_data")}}</div>
            </j-card>

            <!-- Modal for Add Insured -->
            <core-modal name="addInsured" :headline="$t('add_insured')">
                  <select-client
                        for="add_insured"
                        @saved="handleSave()"
                        @cancelled="$modal.hide('addInsured')"
                  />
            </core-modal>
      </div>
</template>

<script>
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import JCard from "@/components/JCard"
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton/"
import CoreModal from "@/modules/core/components/CoreModal"
import SelectClient from "../components/SelectClient"
import api from "../api/"

export default {
	components: {
		CoreEntityCard,
		JCard,
		CrmIcon,
		JButton,
		CoreModal,
		SelectClient
	},

	props: {
		list: {
			type: Array,
			required: true,
			default: () => []
		}
	},

	methods: {
		handleSave() {
			this.$emit("afterAddInsured")
			this.$modal.hide("addInsured")
		},

		async removeInsured(insuredId) {
			const policyId = this.$route.params.id
			const entityId = insuredId

			this.isLoading = true
			const res = await api.removeInsured({
				policyId,
				entityId
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("afterRemoveInsured")
		}
	}
}
</script>